<script lang="ts" setup>
import type { FAQList } from '~~/server/api/faq/[slug]'

export interface PagesFaqMenuProps {
    data: FAQList[]
}

const props = defineProps<PagesFaqMenuProps>()
const route = useRoute()
const { $t } = useNuxtApp()
</script>
<template>
  <h2 class="d-md-none mb-4">
    {{ $t('Súvisiace otázky:') }}
  </h2>
  <ul>
    <PagesFaqMenuItem
      v-for="(link, index) in props.data"
      :key="`faqcai-${index}`"
      :text="link.question"
      :to="{
        name: 'faq-detail',
        params: {
          category: String(route.params.category),
          id: link.slug,
        },
      }"
      :label="link.question"
      class="mb-4"
    />
  </ul>
</template>
